import { render, staticRenderFns } from "./PT480MemberPointDetParts.vue?vue&type=template&id=5cf36a1b&"
import script from "./PT480MemberPointDetParts.vue?vue&type=script&lang=js&"
export * from "./PT480MemberPointDetParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports